const r=r=>{const{name:e,registrationNumber:n}=r;return{...(e||n)&&{company:{...e&&{name:e},...n&&{registrationNumber:n}}}}};export{r as getFormattedData};
//# sourceMappingURL=utils.js.map
